import { SearchBox } from "@elastic/react-search-ui";
import { Heading, InputView, Options } from "components/common";
import { CodeSystem } from "context/elasticsearch/types";
import { t } from "i18next";
import { styled } from "styled-components";
import { getCodeSystemName, getCodeSystemOid } from "utils";

type SearchHeaderProps = {
  codeSystem: CodeSystem;
};

const SearchSectionWrapper = styled.div`
  background-color: ${(props) => props.theme.colours.primary.white};
`;

const CodeSystemSearchHeader = ({ codeSystem }: SearchHeaderProps) => {
  return (
    <SearchSectionWrapper id="search-wrapper" className="p-2">
      <div
        className="d-flex gap-3 justify-content-between p-0"
        id="searchOption"
      >
        <label
          id={`${codeSystem}-search-label`}
          htmlFor={`${codeSystem}-search-input`}
        >
          {/* Heading above search bar */}
          <Heading
            variant="h1"
            className="fs-4 fw-bold fs-md-3 mb-2"
            id={`${codeSystem}-page-title`}
          >
            {t("general.searchTitle", {
              term: getCodeSystemName(codeSystem as string)
            })}{" "}
            {getCodeSystemOid(codeSystem as string) !== "" && (
              <span style={{ color: "gray", fontWeight: "normal" }}>
                ({getCodeSystemOid(codeSystem as string)})
              </span>
            )}
          </Heading>
        </label>
        <Options /> {/* Flere valg meny */}
      </div>

      {/* Search bar */}
      <SearchBox
        searchAsYouType
        autocompleteResults={false}
        autocompleteSuggestions={false}
        shouldClearFilters={false}
        debounceLength={500}
        inputView={InputView}
      />
    </SearchSectionWrapper>
  );
};

export default CodeSystemSearchHeader;
